import React from 'react'
import { SUPPORT_EMAIL } from '../../utils/consts'

const PrivacyPolicy = () => {
	return (
		<div className='container'>
			<h1 className='text-xl md:text-2xl'>
				Политика обработки и конфиденциальности персональных данных
			</h1>

			<p className='mt-5'>Общие положения</p>

			<p className='mt-10'>
				Настоящая политика конфиденциальности в Обществе с ограниченной ответственностью
				«ГИР СТОР» (далее – Политика) определяет цели, содержание, особенности и порядок
				обработки персональных данных, меры, направленные на защиту персональных данных, а
				также процедуры, направленные на выявление и предотвращение нарушений
				законодательства Российской Федерации в области персональных данных в ООО «ГИР СТОР»
				(ИНН 3300013334).
				<br />
				Обработка персональных данных в ООО «ГИР СТОР» осуществляется с соблюдением
				принципов и условий, предусмотренных настоящей Политикой и законодательством
				Российской Федерации в области персональных данных.
				<br />
				Использование сайта означает безоговорочное согласие субъекта персональных данных с
				настоящей Политикой и указанными в ней условиями. В случае несогласия с этими
				условиями пользователь должен воздержаться от использования сайта, заключения
				договоров, иного взаимодействия с ООО «ГИР СТОР», предполагающего передачу
				персональных данных. Политика применяется только к сервисам и правовому
				взаимодействию с ООО «ГИР СТОР», не регулирует действия на сайтах и других сервисах
				третьих лиц, на которые пользователь может перейти по ссылкам.
				<br />
			</p>

			<h2 className='mt-5 text-xl font-bold'>1. Термины и определения</h2>
			<ul className='mt-3'>
				<li>
					Персональные данные – любая информация, относящаяся прямо или косвенно к
					определенному или определяемому физическому лицу (субъекту персональных данных);
				</li>
				<li>
					Оператор персональных данных (Оператор) – ООО «ГИР СТОР» – юридическое лицо,
					осуществляющее обработку персональных данных, определяющее цели обработки
					персональных данных, состав персональных данных, подлежащих обработке, действия
					(операции), совершаемые с персональными данными;
				</li>
				<li>
					<strong>Субъекты персональных данных (Субъекты):</strong>
				</li>
				<li>
					Пользователь – лицо, направившее Оператору персональные данные, посредством
					заполнения формы на сайте;
				</li>
				<li>
					Посетитель – лицо, осуществившее переход на страницу сайта Оператора, но не
					передавшее ему персональные данные;
				</li>
				<li>
					Контрагент/Заказчик – лицо, с которым Оператор вступил в договорные отношения
					или ведет переговоры (потенциальный контрагент/заказчик);
				</li>
				<li>
					Сотрудник – лицо, с которым Оператор заключил трудовой договор или соискатель на
					замещение вакансии;
				</li>
				<li>
					Обработка персональных данных – любое действие (операция) или совокупность
					действий (операций) с персональными данными, в том числе:
					<br /> - сбор;
					<br /> - запись;
					<br /> - систематизация;
					<br /> - накопление;
					<br /> - хранение;
					<br /> - уточнение (обновление, изменение);
					<br /> - извлечение;
					<br /> - использование;
					<br /> - передача;
					<br /> - обезличивание;
					<br /> - блокирование;
					<br /> - удаление;
					<br /> - уничтожение.
				</li>
				<li>
					Автоматизированная обработка персональных данных — обработка персональных данных
					с помощью средств вычислительной техники;
				</li>
				<li>
					Распространение персональных данных — действия, направленные на раскрытие
					персональных данных неопределенному кругу лиц;
				</li>
				<li>
					Блокирование персональных данных — временное прекращение обработки персональных
					данных (за исключением случаев, если обработка необходима для уточнения
					персональных данных);
				</li>
				<li>
					Уничтожение персональных данных — действия, в результате которых становится
					невозможным восстановить содержание персональных данных в информационной системе
					персональных данных и (или) в результате которых уничтожаются материальные
					носители персональных данных.
				</li>
			</ul>

			<h2 className='mt-5 text-xl font-bold'>
				2. Порядок и основания обработки персональных данных
			</h2>

			<ul className='mt-3'>
				<li>
					2.1 Персональные данные, которые получает и обрабатывает Оператор:
					<br />
					<strong>По Контрагентам/Заказчикам:</strong>
					<br /> - фамилия;
					<br /> - имя;
					<br /> - отчество;
					<br /> - ИНН;
					<br /> - ОГРИП (для индивидуальных предпринимателей);
					<br /> - номер телефона;
					<br /> - адрес электронной почты;
					<br /> - паспортные данные (серия, номер, кем и когда выдан), место регистрации;
					<br /> - банковские реквизиты.
					<br />
					<strong>По Пользователям:</strong>
					<br /> - имя;
					<br /> - номер телефона;
					<br /> - адрес электронной почты;
					<br /> - IP-адрес;
					<br /> - данные о местоположении.
					<br /> - По посетителям:
					<br /> - IP-адрес;
					<br /> - данные о местоположении.
					<br /> <strong>По сотрудникам/соискателям:</strong>
					<br /> - фамилия;
					<br /> - имя;
					<br /> - отчество;
					<br /> - ИНН;
					<br /> - СНИЛС;
					<br /> - номер телефона;
					<br /> - адрес электронной почты;
					<br /> - паспортные данные (серия, номер, кем и когда выдан), место регистрации;
				</li>
				<li>
					2.2. Сбор и обработка персональных данных осуществляется на основании согласий
					Субъектов, договоров и соглашений.
				</li>
				<li>
					2.3. Согласие Пользователя на обработку персональных данных считается полученным
					Оператором с момента указания данных и проставления специальной отметки –
					галочки в соответствующем поле формы сбора персональных данных на сайте
					Оператора.{' '}
				</li>
				<li>
					2.4. Согласие Контрагента/Заказчика на обработку персональных данных считается
					полученным Оператором с момента указания данных и подписания соответствующего
					договора.
				</li>
				<li>
					2.5. Согласие Сотрудника на обработку персональных данных считается полученным
					Оператором с момента указания данных и подписания письменного согласия в виде
					отдельного документа.
				</li>
				<li>
					2.6. Иных доказательств для дополнительного подтверждения свободного
					волеизъявления не требуется.
				</li>
				<li>
					2.7. Оператор использует персональные данные для достижения следующих целей:
					предоставление доступа к сайту, его содержанию, к функционалу;
					<br /> - идентификация при использовании сайта;
					<br /> - установление обратной связи, включая направление уведомлений и
					запросов;
					<br /> - заключение и исполнение договоров, предоставление услуг, осуществление
					взаиморасчетов;
					<br /> - сбор Оператором статистики;
					<br /> - улучшение качества работы сайта, удобства их использования и разработки
					новых сервисов и услуг;
					<br /> - проведение маркетинговых (рекламных) мероприятий, направления
					Оператором предложений, информационной и рекламной рассылки и получения их
					Субъектом для продвижения на рынке услуг Оператора, в том числе, путем
					осуществления прямых контактов;
					<br /> - соблюдение трудового законодательства РФ.
				</li>
				<li>
					2.8. Оператор осуществляет автоматизированную обработку персональных данных.
				</li>
				<li>
					2.9. Обработка и&nbsp;хранение персональных данных осуществляются
					не&nbsp;дольше, чем этого требуют цели обработки, если федеральным законом
					или&nbsp;соглашением с&nbsp;Субъектом персональных данных не&nbsp;установлен
					соответствующий срок хранения.
				</li>
				<li>
					2.10. Обрабатываемые персональные данные подлежат уничтожению либо обезличиванию
					при&nbsp;наступлении следующий условий:&nbsp;
					<br /> - достижение целей обработки персональных данных либо утрата
					необходимости в&nbsp;достижении целей обработки;&nbsp;
					<br /> - отзыв Субъектом персональных данных согласия на&nbsp;обработку
					персональных данных, если сохранение персональных данных более не&nbsp;требуется
					для&nbsp;целей обработки персональных данных;&nbsp;
					<br /> - прекращение деятельности Оператора.
				</li>
				<li>
					2.11. Уничтожение персональных данных осуществляется путем стирания из всех баз
					и со всех носителей.
				</li>
			</ul>

			<h2 className='mt-5 text-xl font-bold'>
				3. Данные файлов cookie и иных технологий отслеживания
			</h2>
			<ul className='mt-3'>
				<li>
					Данные об устройстве Пользователя/Посетителя, которые автоматически передаются
					Оператору Сайтом в процессе его использования с помощью установленного на
					устройстве программного обеспечения, в том числе информация из cookie:
					<br /> - адрес интернет-протокола компьютера пользователя/посетителя (например,
					IP-адрес);
					<br /> - тип браузера, версия браузера;
					<br /> - страницы Сайта, время посещения пользователя/посетителя, время,
					потраченное на эти страницы;
					<br /> - уникальные идентификаторы устройств и другие диагностические данные,
					тип мобильного устройства, IP-адрес мобильного устройства, мобильная
					операционная система, тип мобильного интернет-браузера;
					<br /> - иные данные файлов cookie.
				</li>
				<li>
					3.2. Данные файлов cookie (сookie-файлы) и аналогичные технологии отслеживания
					Оператор использует для отслеживания активности и хранения информации.
					Сookie-файлы представляют собой файлы с небольшим количеством данных, которые
					могут включать анонимный уникальный идентификатор. Cookie-файлы отправляются в
					браузер с веб-сайта и хранятся на устройстве пользователя/посетителя. Технологии
					отслеживания, которые также используются, — это маяки, теги и сценарии для сбора
					и отслеживания информации, а также для улучшения сервисов.
				</li>
				<li>
					3.3. Пользователь/Посетитель может отказаться от всех cookie-файлов (при
					изменении настроек браузера, а также при изменении настроек сервиса при наличии
					технической возможности). При отказе от использования cookie-файлов
					пользователь/посетитель соглашается с тем, что некоторые части (функции)
					сервисов могут быть ему недоступны для использования.
				</li>
			</ul>

			<h2 className='mt-5 text-xl font-bold'>4. Конфиденциальность персональных данных</h2>
			<ul className='mt-3'>
				<li>
					4.1. Оператор ни в коем случае не продает, не передает в пользование и не
					раскрывает персональные данные Субъектов третьим лицам, а также не использует их
					для каких-либо целей, кроме указанных в настоящей Политике.
				</li>
				<li>
					4.2. Оператор осуществляет обработку персональных данных в форме, позволяющей
					определить субъекта персональных данных, не дольше, чем этого требуют цели
					обработки персональных данных.
				</li>
				<li>
					4.3. Оператор предпринимает необходимые и&nbsp;достаточные правовые,
					организационные и&nbsp;технические меры для&nbsp;обеспечения безопасности
					персональных данных для&nbsp;их защиты от&nbsp;несанкционированного (в&nbsp;том
					числе, случайного) доступа, уничтожения, изменения, блокирования доступа
					и&nbsp;других несанкционированных действий. К&nbsp;таким мерам,
					в&nbsp;частности, относятся:&nbsp;
					<br /> - назначение лиц, ответственных за&nbsp;организацию обработки
					и&nbsp;обеспечение безопасности персональных данных;&nbsp;
					<br /> - издание локальных актов по&nbsp;вопросам обработки персональных данных,
					информационной безопасности, ознакомление с&nbsp;ними сотрудников;&nbsp;
					<br /> - обучение сотрудников (при их наличии) по&nbsp;вопросам обработки
					персональных данных, обеспечения информационной безопасности;&nbsp;
					<br /> - обеспечение физической безопасности помещений и&nbsp;средств
					обработки;&nbsp;
					<br /> - мониторинг действий с&nbsp;персональными данными;&nbsp;
					<br /> - определение угроз безопасности персональных данных при&nbsp;их
					обработке в&nbsp;информационных системах персональных данных, формирование
					на&nbsp;их основе моделей угроз;&nbsp;
					<br /> - применение средств обеспечения безопасности (антивирусных средств,
					межсетевых экранов, средств защиты от&nbsp;несанкционированного доступа),
					в&nbsp;том числе, в&nbsp;необходимых случаях, прошедших процедуру оценки
					соответствия в&nbsp;установленном порядке;&nbsp;
					<br /> - учёт и&nbsp;хранение носителей информации, исключающее их хищение,
					подмену, несанкционированное копирование и&nbsp;уничтожение;&nbsp;
					<br /> - резервное копирование информации для&nbsp;возможности
					восстановления;&nbsp;
					<br /> - проверка эффективности принятых мер, реагирование
					на&nbsp;инциденты;&nbsp;
					<br /> - иные возможные и необходимые меры.&nbsp;
				</li>
				<li>
					4.4. Оператор вправе передать персональную информацию Субъекта и/или поручить ее
					обработку третьим лицам в следующих случаях:
					<br /> - пользователь выразил согласие на такие действия;
					<br /> - передача необходима для использования Субъектом сервисов либо для
					исполнения договора с ним;
					<br /> - в целях обеспечения возможности защиты прав и законных интересов
					Оператора;
					<br /> - передача предусмотрена российским или иным применимым законодательством
					в рамках установленной законодательством процедуры.
				</li>
				<li>
					4.5. Представители органов государственной власти (в том числе, контролирующих,
					надзорных, правоохранительных, дознания и следствия и иных уполномоченных
					органов по основаниям, предусмотренным действующим законодательством Российской
					Федерации) получают доступ к персональным данным, обрабатываемым Оператором, в
					объеме и порядке, установленном законодательством Российской Федерации.
				</li>
				<li>
					4.6. Сервисы Оператора могут содержать ссылки на другие сайты, которые не
					управляются Оператором. Если Субъект переходит по ссылке, то он попадет на сайт
					третьей стороны. Оператор настоятельно рекомендует Субъектам ознакомиться с
					политикой конфиденциальности на каждом сайте, который он посещает. Оператор не
					контролирует и не несет никакой ответственности за контент, политику
					конфиденциальности или действия сторонних сайтов или услуг третьих лиц.
				</li>
			</ul>

			<h2 className='mt-5 text-xl font-bold'>
				5. Ответственный за обработку персональных данных, назначенный Оператором:
			</h2>
			<ul className='mt-3'>
				<li>
					- осуществляет внутренний контроль за соблюдением Оператором законодательства
					Российской Федерации о персональных данных, в том числе требований к защите
					персональных данных;
				</li>
				<li>
					- контролирует прием и обработку обращений и запросов субъектов персональных
					данных или их представителей;
				</li>
				<li>
					- принимает меры для обнаружения фактов несанкционированного доступа к
					персональным данным и немедленного доведения этой информации до руководителя;
				</li>
				<li>
					- производит постоянный контроль за обеспечением уровня защищенности
					персональных данных;
				</li>
				<li>
					- осуществляет внутренний контроль и (или) аудит соответствия обработки
					персональных данных закону 152-ФЗ и принятым в соответствии с ним нормативными
					правовыми актами, требованиям к защите персональных данных, политике Оператора в
					отношении обработки персональных данных, локальным актам Оператора.
				</li>
			</ul>

			<h2 className='mt-5 text-xl font-bold'>
				6. Права и обязанности Субъекта персональных данных
			</h2>
			<ul className='mt-3'>
				<li>
					6.1. Оператор предпринимает разумные меры для поддержания точности и
					актуальности, имеющихся у него персональных данных, а также удаления устаревших
					и других недостоверных или излишних персональных данных, тем не менее, Субъект
					несет ответственность за предоставление достоверных сведений, а также за
					обновление предоставленных данных в случае каких-либо изменений.
				</li>
				<li>
					6.2. Субъект может в любой момент изменить (обновить, дополнить, блокировать,
					уничтожить) предоставленную им персональную информацию или её часть, а также
					параметры её конфиденциальности путем обращения к Оператору.
				</li>
				<li>
					6.3. Субъект вправе в любой момент отозвать согласие на обработку Оператором
					персональных данных путём направления письменного уведомления на электронный
					адрес:&nbsp;
					<a href={`mailto:${SUPPORT_EMAIL}`} className='link'>
						{SUPPORT_EMAIL}
					</a>{' '}
					с пометкой «отзыв согласия на обработку персональных данных», при этом отзыв
					пользователем согласия на обработку персональных данных влечёт за собой
					уничтожение персональных данных. Уведомление Субъекта должно содержать сведения
					о том, когда и в связи с чем персональные данные были переданы Оператору
				</li>
				<li>
					6.4. Субъект имеет право на получение информации, касающейся обработки его
					персональных данных Оператором.
				</li>
				<li>
					6.5. Субъект вправе запрашивать у Оператора информацию, касающуюся обработки его
					персональных данных. Для этого нужно отправить запрос по электронному адресу,
					указанному в п 6.3. Политики. Запрос Субъекта должен содержать сведения о том,
					когда и в связи с чем персональные данные были переданы Оператору.
				</li>
				<li>
					6.6. Субъект вправе направлять запросы на уточнение, актуализацию персональных
					данных, заявления об отзыве согласия на обработку персональных данных по
					электронному адресу, указанному в п 6.3. Политики.
				</li>
				<li>
					6.7. Срок, в течение которого Оператор обязан рассмотреть любое обращение
					Субъекта – 10 календарных дней.
				</li>
			</ul>

			<p className='mt-3'>
				7. При предоставлении Оператору Субъектом персональных данных третьих лиц
				ответственность за получение согласия на обработку персональных данных этих лиц и на
				передачу их Оператору, за последствия передачи несет Субъект. Оператор исходит из
				того, что согласия от этих лиц Субъектом получены.
			</p>

			<p className='mt-3'>
				8. Политика является доступным документом Оператора и&nbsp;предусматривает
				возможность ознакомления любых лиц с&nbsp;ее действующей версией, путем размещения
				на сайте и других ресурсах Оператора. Изменения в Политику Оператор вносит без
				уведомления об этом Субъектов персональных данных.
			</p>

			<p className='mt-3'>
				«18» апреля 2025 г.
				<br />
				<strong>ООО «ГИР СТОР»</strong>
				<br />
				<br />
				Адрес электронной почты:{' '}
				<a className='link' href={`mailto:${SUPPORT_EMAIL}`}>
					{SUPPORT_EMAIL}
				</a>
			</p>
		</div>
	)
}

export default PrivacyPolicy
